import { render, staticRenderFns } from "./ModalChatEvent.vue?vue&type=template&id=113b3664&"
import script from "./ModalChatEvent.vue?vue&type=script&lang=js&"
export * from "./ModalChatEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports